/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'LASER_RADIATION_EQUIPMENT_IS_MAINTAINED_AND_REGULARLY_INSPECTED',
              'LASER_RADIATION_EQUIPMENT_HAVE_THE_APPROPRIATE_PROTECTION',
              'LASER_RADIATION_EQUIPMENT_HAS_THE_APPROPRIATE_SIGNS',
              'WORKERS_WORKING_WITH_RADIATION_SOURCES_ARE_PROTECTED_AND_NOT_EX',
              'WORKERS_THAT_WORK_WITH_LASER_RADIATION_PRODUCING_EQUIPMENT_UNDE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_12: valueSchema,
  },
}
